import React from "react";
import {
  TTP_HOME_URL,
  TTP_POWER_TEAM_URL,
  PERIOD_UNIT,
  URL_HASH_KEY
} from "Config";
import moment from "moment";
import _ from "i18n";
import { NotificationManager } from "react-notifications";
// import AES from "crypto-js/aes";
// import EncUtf8 from "crypto-js/enc-utf8";
import CryptoJS from "crypto-js";
export const getDefaultLanguage = () => {
  const lng = navigator.language || navigator.userLanguage;
  return ["fr", "en", "nl"].includes(lng) ? lng : "en";
};

export const redirectToHome = (returnTo = "") => {
  const goto = encodeURI(TTP_POWER_TEAM_URL + "/" + returnTo);
  window.location.assign(`${TTP_HOME_URL}?goto=${goto}`);
};

export const getURLEmbeddedParam = location => {
  const searchParams = new URLSearchParams(location.search);
  return {
    embedded: searchParams.get("embedded") || "false"
  };
};

export const abbreviateNumber = (num, digits = 2) => {
  var units = ["k", "M", "G", "T", "P", "E"],
    decimal;

  for (var i = units.length - 1; i >= 0; i--) {
    decimal = Math.pow(1000, i + 1);

    if (num <= -decimal || num >= decimal) {
      return +(num / decimal).toFixed(digits) + " " + units[i];
    }
  }

  return num;
};

export const getTimeByDuration = duration => {
  var sec_num = parseFloat(duration) * 3600;
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - hours * 3600) / 60);

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }

  return hours + "H" + minutes;
};

export const getTimeByDurationFormat = (duration, spaces) => {
  var sec_num = parseFloat(duration) * 3600;
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - hours * 3600) / 60);

  if (hours < 10 && hours >= 0) {
    hours = "0" + getFormatNumber(hours);
  } else {
    hours = getFormatNumber(hours);
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (spaces) {
    return hours + "h " + minutes + " min";
  } else {
    return hours + "H" + minutes;
  }
};

export const getFormatNumber = number => {
  return new Intl.NumberFormat("de-DE").format(number);
};

export function renderPeriodsByRangeDateAndPeriodUnit(
  startDate,
  endDate,
  period
) {
  switch (period) {
    case PERIOD_UNIT.YEAR: {
      return renderAnnualPeriods(startDate, endDate);
    }
    case PERIOD_UNIT.SEMESTER: {
      return renderBiannualPeriods(startDate, endDate);
    }
    case PERIOD_UNIT.QUARTER: {
      return renderQuarterlyPeriods(startDate, endDate);
    }
    case PERIOD_UNIT.MONTH: {
      return renderMonthlyPeriods(startDate, endDate);
    }
    case PERIOD_UNIT.DATE: {
      return [
        startDate.format("YYYY-MM-DD") + "|" + endDate.format("YYYY-MM-DD")
      ];
    }
    default:
      return renderAnnualPeriods(startDate, endDate);
  }
}

function renderAnnualPeriods(startDate, endDate) {
  let periods = [];
  for (let index = startDate.year(); index <= endDate.year(); index++) {
    periods.push(index);
  }
  return periods;
}

function renderBiannualPeriods(startDate, endDate) {
  let firstHalf =
    startDate.year() + "" + "/".concat(startDate.quarter() <= 2 ? 1 : 2);
  let lastHalf =
    endDate.year() + "" + "/".concat(endDate.quarter() <= 2 ? 1 : 2);
  let periods = [firstHalf];

  if (firstHalf === lastHalf) {
    return periods;
  }

  for (let year = startDate.year(); year <= endDate.year(); year++) {
    for (let half = 1; half <= 2; half++) {
      let localHalf = year + "" + "/".concat(half);
      if (
        lastHalf.localeCompare(localHalf) > 0 &&
        firstHalf.localeCompare(localHalf) < 0
      ) {
        periods.push(localHalf);
      }
    }
  }
  periods.push(lastHalf);
  return periods;
}

function renderQuarterlyPeriods(startDate, endDate) {
  let firstQuarter = startDate.year() + "" + "/".concat(startDate.quarter());
  let lastQuarter = endDate.year() + "" + "/".concat(endDate.quarter());
  let periods = [firstQuarter];

  if (firstQuarter === lastQuarter) {
    return periods;
  }

  for (let year = startDate.year(); year <= endDate.year(); year++) {
    for (let quarter = 1; quarter <= 4; quarter++) {
      let localQuarter = year + "" + "/".concat(quarter);
      if (
        lastQuarter.localeCompare(localQuarter) > 0 &&
        firstQuarter.localeCompare(localQuarter) < 0
      ) {
        periods.push(localQuarter);
      }
    }
  }
  periods.push(lastQuarter);
  return periods;
}

function renderMonthlyPeriods(startDate, endDate) {
  let firstMonth =
    startDate.year() +
    ""
      .concat(startDate.month() + 1 < 10 ? "/0" : "/")
      .concat(startDate.month() + 1);
  let lastMonth =
    endDate.year() +
    ""
      .concat(endDate.month() + 1 < 10 ? "/0" : "/")
      .concat(endDate.month() + 1);
  let periods = [firstMonth];

  for (let year = startDate.year(); year <= endDate.year(); year++) {
    for (let month = 1; month <= 12; month++) {
      let localMonth = year + "".concat(month < 10 ? "/0" : "/").concat(month);
      if (
        lastMonth.localeCompare(localMonth) > 0 &&
        firstMonth.localeCompare(localMonth) < 0
      ) {
        periods.push(localMonth);
      }
    }
  }
  periods.push(lastMonth);
  return periods;
}

export function onSuccess(res, message = null) {
  if (!message) {
    message = { body: "operationCompleted", title: "successfulAction" };
  }
  if (res.value instanceof Error) {
    NotificationManager.error(_("incompleteOperation"), _("error"));
  } else {
    NotificationManager.success(_(message.body), _(message.title));
  }
}

export function onError(message) {
  if (!message) {
    message = "errorOccured";
  }
  NotificationManager.error(_(message), _("error"));
}

export const getUrlParams = (location, param) => {
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get(param) || null;
};

export const getScrollbarWidth = () => {
  return window.innerWidth - document.documentElement.clientWidth;
};

export const isMacOS = () => {
  return window.navigator.userAgent.indexOf("Mac OS X") !== -1;
};

export const renderRatingStars = (id, value) => {
  let stars = [];
  for (let i = 0; i < 5; i++) {
    stars.push(i === 0 ? i < value.rate : i <= value.rate);
  }
  return stars.map((s, k) => (
    <img
      key={id + k}
      alt={""}
      src={
        s
          ? value.rate > 6.5
            ? "/img/icons/gold_star.svg"
            : "/img/icons/star.svg"
          : "/img/icons/light_star.svg"
      }
    />
  ));
};

export const ucfirst = value => {
  return value && value.length > 1
    ? `${value[0].toUpperCase()}${value.substring(1)}`
    : "";
};

export const resolveNullability = value => {
  return value && value.trim() !== "" ? value : "-";
};
export const getURLWithoutHeaderParam = location => {
  const searchParams = new URLSearchParams(location.search);
  return {
    withoutHeader: searchParams.has("without_header")
  };
};

export const getCollaboratorRoles = roles => {
  const listRoles = roles.split(", ");
  return listRoles.map(role => _(role) + " ");
};

export const getURLParams = location => {
  const searchParams = new URLSearchParams(location.search);
  let hashParams = searchParams.get("params") || null;
  let tab = {
    queryToken: "",
    uaWithoutHeader: false,
    teamWithoutMenu: false,
    userId: null,
    teamCalendarYear: null,
    organization_id: null
  };
  if (hashParams) {
    hashParams = decryptWithAES(decodeURIComponent(hashParams));
    const tabQueryParams = hashParams.split(",");
    tabQueryParams.forEach(item => {
      const tmp = item.split("=");
      if (tmp.length > 0) {
        if (tmp[0] === "token") {
          tab.queryToken = tmp[1];
        } else if (tmp[0] === "userId") {
          tab.userId = tmp[1];
        } else if (tmp[0] === "without_header") {
          tab.uaWithoutHeader = true;
        } else if (tmp[0] === "without_menu") {
          tab.teamWithoutMenu = true;
        } else if (tmp[0] === "organization_id") {
          tab.organization_id = tmp[1];
        } else if (tmp[0] === "year") {
          tab.teamCalendarYear = tmp[1];
        }
      }
    });
  }
  return tab;
};

export const decryptWithAES = ciphertext => {
  var encryptMethod = "AES-256-CBC";
  var aesNumber = encryptMethod.match(/\d+/)[0];
  var encryptMethodLength = parseInt(aesNumber);

  var json = JSON.parse(
    CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(ciphertext))
  );

  var salt = CryptoJS.enc.Hex.parse(json.salt);
  var iv = CryptoJS.enc.Hex.parse(json.iv);

  var encrypted = json.ciphertext; // no need to base64 decode.

  var iterations = parseInt(json.iterations);
  if (iterations <= 0) {
    iterations = 999;
  }
  var encryptMethodLength = encryptMethodLength / 4; // example: AES number is 256 / 4 = 64
  var hashKey = CryptoJS.PBKDF2(URL_HASH_KEY, salt, {
    hasher: CryptoJS.algo.SHA512,
    keySize: encryptMethodLength / 8,
    iterations: iterations
  });

  var decrypted = CryptoJS.AES.decrypt(encrypted, hashKey, {
    mode: CryptoJS.mode.CBC,
    iv: iv
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
};

export const renderTeamYears = () => {
  let years = [];
  let year = 2020;

  while (year <= moment().year()) {
    years.push(year);
    year++;
  }
  return years;
};

export const formatAmount = (amount, addCurrency = true) => {
  if (!addCurrency) {
    return new Intl.NumberFormat("de-DE", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  }
  return (
    new Intl.NumberFormat("de-DE", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount) + "€"
  );
};

export const parsePreference = preference => {
  return preference ? JSON.parse(preference) : {};
};

/**
 * allowViewDataBy options:
 * - No access: 0
 * - All: 1
 * - Personal: 10
 * - Partnership: 11
 * - BU: 100
 * - Zone: 101
 * - Backup: 110
 */
export const viewDataBy = (
  preferences,
  list = [],
  collaborator,
  subPreference = ""
) => {
  let data;
  const parsed = subPreference
    ? parsePreference(preferences)[subPreference]
    : parsePreference(preferences);
  const viewBy = parsed.allowViewDataBy || 1;

  if (viewBy === 10) {
    data = list
      .filter(item => item.id == collaborator.id)
      .map(
        item =>
          item.id == collaborator.id
            ? { ...item, isActif: true }
            : { ...item, isActif: false }
      );
  } else if (viewBy === 11) {
    data = list.filter(
      item => item.partner.value == collaborator.partner.value
    );
  } else if (viewBy === 100) {
    data = list
      .filter(item => item.bu == collaborator.bu)
      .map(
        item =>
          item.id == collaborator.id
            ? { ...item, isActif: true }
            : { ...item, isActif: false }
      );
  } else if (viewBy === 101) {
    data = list
      .filter(item => item.zone == collaborator.zoneId)
      .map(
        item =>
          item.id == collaborator.id
            ? { ...item, isActif: true }
            : { ...item, isActif: false }
      );
  } else if (viewBy === 110) {
    data = list
      .filter(
        item =>
          collaborator.backupIds.includes(item.id) || item.id == collaborator.id
      )
      .map(
        item =>
          item.id == collaborator.id
            ? { ...item, isActif: true }
            : { ...item, isActif: false }
      );
  } else {
    data = list.map(
      item =>
        item.id == collaborator.id
          ? { ...item, isActif: true }
          : { ...item, isActif: false }
    );
  }

  return data;
};



// WEBPACK FOOTER //
// ./src/utils/common.js